import { useCallback } from 'react';

export const useUpdateDisplayInfo = () => {
	const updateDisplayInfo = useCallback((currentData, prevData) => {
		const display = { ...currentData.display };

		const currentMode = currentData.hud.mode;
		const prevRun = prevData.mode.run;
		const currentRun = currentData.mode.run;

		if (currentMode === 'AUTONOMOUS') {
			display.mode = false;
		}
		if (!currentRun && prevRun) {
			display.mode = true;
		}

		return display;
	}, []);

	return { updateDisplayInfo };
};
